import React from "react";
import { OrderRouteLayer } from "@src/features/order/components";
import { CompletedMapProps } from "./types";

const CompletedMap: React.FC<CompletedMapProps> = (props) => {
  const { order } = props;

  if (!order) return null;

  return <OrderRouteLayer order={order} droneVariant="idleGray" />;
};

export default CompletedMap;
